import React from 'react';
import { Modal, Input, Button } from 'antd';
import { useCallback, useState } from 'react';
import { useArtboardContext } from '../../context/complexArtboardContext';
import { CONTEXT_KEYS } from '../../context/complexArtboardContext';
import { GROUPING_MODAL } from './translationValues';
import { useTranslation } from 'react-i18next';

const NAMESPACES = ['GROUPING_MODAL'];

export const GroupNameModal = ({
  showPopOver,
  groupingElements,
  setGroupName,
  groupedElementIds,
}) => {
  const { t } = useTranslation(NAMESPACES);
  const artboardSelector = useCallback(store => null, []);
  const [, updateArtboard] = useArtboardContext(artboardSelector);

  const actionItemSelector = useCallback(store => store[CONTEXT_KEYS.GROUP_ACTION_ITEM], []);
  const [actionItem] = useArtboardContext(actionItemSelector);

  const [groupName1, setGroupName1] = useState('');

  const handleClose = () => {
    updateArtboard({
      [CONTEXT_KEYS.GROUP_NAME_MODAL]: false,
    });
  };

  const handleSave = () => {
    setGroupName(groupName1);
    groupingElements(actionItem, groupedElementIds, groupName1);
    updateArtboard({
      [CONTEXT_KEYS.GROUP_NAME_MODAL]: false,
    });
  };

  const handleChange = e => {
    setGroupName1(e.target.value);
  };

  return (
    <Modal
      title={null}
      centered
      maskClosable={false}
      visible={showPopOver}
       width="450px"
        style={{
        padding: 0,
        borderRadius: '10px',
        overflow: 'hidden',
      }}
      bodyStyle={{
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
      }}
      footer={null}
      closable={true}
      onCancel={() => {
        handleClose();
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
        <p style={{ margin: 0, fontWeight: '600', fontSize: '14px' }}>
          {t(
            GROUPING_MODAL.GROUP_NAME.key,
            GROUPING_MODAL.GROUP_NAME.value,
          )}
        </p>
        <Input onChange={handleChange}
          placeholder={t(
            GROUPING_MODAL.GROUP_NAME_PLACEHOLDER.key,
            GROUPING_MODAL.GROUP_NAME_PLACEHOLDER.value,
          )}
          style={{ borderRadius: '6px', outline: '1px solid grey' }} />
      </div>

      <div
        style={{display: 'flex',
        justifyContent:'center'
        }}
      >
        <Button
          type="primary"
          onClick={handleSave}
          style={{
            borderRadius: '80px',
            padding: '0 20px',
            width: '45%',
            backgroundColor: '#FFEB3B',
            color: 'black',
            border: 'none'
          }}
        >
          {t(
            GROUPING_MODAL.GROUP_NAME_SAVE.key,
            GROUPING_MODAL.GROUP_NAME_SAVE.value,
          )}
        </Button>
      </div>
    </Modal>
  );
};
